<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>会员设置</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          class="search-form"
          size="small"
        >
          <el-form-item label="会员名称" prop="name">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入会员名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="有效期" prop="expireDate">
            <el-select
              v-model="searchForm.expireDate"
              placeholder="请选择有效期"
              filterable
              clearable
            >
              <el-option
                v-for="item in expireDates"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择状态"
              filterable
              clearable
            >
              <el-option
                v-for="item in statuss"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="getList('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div style="display: flex; align-items: center">
          <h3 style="margin-bottom: 0">列表数据</h3>
          <div
            style="
              display: flex;
              align-items: center;
              margin-left: 20px;
              background-color: rgba(65, 104, 231, 0.1);
              padding: 6px 20px;
              border-radius: 18px;
              font-size: 16px;
              color: #333;
            "
          >
            <span style="margin-right: 20px">平台是否开启会员</span>
            <el-switch v-model="value" @change="isStart"></el-switch>
          </div>
        </div>
        <div>
          <el-button type="primary" @click="add('add')">新增会员</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-loading="loading"
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo"
          :page-size="searchForm.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>
  <script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data () {
    return {
      value: false,
      dataList: {
        list: [
          { title: '矩阵管理', path: '', type: '0' },
          { title: '平台列表', path: '', type: '1' }
        ]
      },
      expireDates: [
        {
          dictId: '1',
          dictName: '一个月'
        },
        {
          dictId: '3',
          dictName: '三个月'
        },
        {
          dictId: '12',
          dictName: '一年'
        },
        {
          dictId: '0',
          dictName: '永久'
        },
      ],
      searchForm: {
        // id: '',
        name: '',
        expireDate: '',
        status: '',
        pageNo: 1,
        pageSize: 10
      },
      openTime: [],
      statuss: [
        {
          id: '1',
          name: '已启用'
        },
        {
          id: '0',
          name: '已禁用'
        }
      ],
      list: [
        // {
        //   name: '天兰',
        //   image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        // },
        // {
        //   image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        // },
        // {
        //   image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        // }
      ],
      columns: [
        { label: '会员名称', prop: 'name', minWidth: '120' },
        { label: '有效期', prop: 'expirationDate', minWidth: '120' },
        { label: '价格', prop: 'price', minWidth: '120' },
        {
          label: '创建时间', prop: 'createdTime', minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.createdTime ? scope.row.createdTime : '--'}</p>
              </div>
            )
          }
        },
        { label: '购买数量', prop: 'purchaseQuantity', minWidth: '120' },

        {
          label: '状态',
          minWidth: '100',
          render: (h, scope) => {
            return (
              <div>
                <p class={scope.row.statusLabel === '已启用' ? 'success' : 'danger'}>{scope.row.statusLabel}</p>
              </div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '180',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-link size='mini' type='primary' onClick={() => { this.add('edit', scope.row.id) }}>查看/编辑</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('Equity', scope.row.id) }}>会员权益</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.deriveDeliver(scope.row.id) }}>导出购买记录</el-link>
              </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      categoryList: [],
      dictionaries: {},
      loading: false
    }
  },
  created () {
    this.getCategoryList()
    this.getDetail(this.$route.query.id)
    this.getList()
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == 'platListDetail') {
      next(vm => {
        vm.getList();
      });
    } else {
      next(vm => {
        vm.getList();
      });
    }
  },
  mounted () {

  },
  methods: {
    isStart () {
      let memberSwitch = 0
      if (this.value == true) {
        memberSwitch = 1
      } else {
        memberSwitch = 0
      }
      let data = {
        id: this.$route.query.id,
        memberSwitch: memberSwitch
      }
      this.$api.updateSwitchMember(data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.getDetail(this.$route.query.id)
        }
      })
    },
    getDetail (id) {
      this.$api.getPlatformInfo({ id: id }).then(res => {
        if (res.code == 0) {
          if (res.data.memberSwitch == 0) {
            this.value = false
          } else {
            this.value = true
          }
        }
      })
    },
    //导出
    deriveDeliver (id) {
      let data = {
        platformId: this.$route.query.id,
        membersId: id,
        page: this.searchForm.pageNo,
        pageSize: this.searchForm.pageSize
      }
      this.$api.exportUseList(data).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink (url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    onChangeCategory () {

    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.searchForm.pageNo = currentChange
      this.getList()
    },
    handleSizeChange (sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.getList()
    },
    getList (type) {
      
      if (type == 'reset') {
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      this.searchForm.platformId = this.$route.query.id
      this.$api.getMembersPageList(this.searchForm).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            item.price = Number(item.price).toFixed(2)
            if (item.status == 1) {
              item.statusLabel = '已启用'
            } else {
              item.statusLabel = '已禁用'
            }
          })
          this.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false;
        }
      })
    },
    // 获取字典数据
    getDictionaries (type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries['platform_vip_level'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList () {
      const params = {}
      this.$api.categoryList(params).then((res) => {
        res.data.list.forEach(item => {
          if (item.children) {
            item.children.forEach(itm => {
              if (itm.children) {
                delete itm.children
              }
            })
          }
        })
        this.categoryList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    add (type, id) {
      if (type == 'look') {
        this.$router.push({
          name: 'lookPlatform',
          query: {
            type: type,
            id: id
          }
        })
      } else if (type == 'Equity') {
        this.$router.push({
          name: 'vipEquity',
          query: {
            type: type,
            platformId: this.$route.query.id,
            id: id
          }
        })
      } else if (type == 'add' || type == 'edit') {
        this.$router.push({
          name: 'newVip',
          query: {
            type: type,
            id: this.$route.query.id,
            vipId: id
          }
        })
      }

    },
    setting () {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
  </script>
  <style  lang="scss">
.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
  <style scoped lang="scss">
::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}
::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}
.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;
      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
  
  